(ns common.widgets.meta-alerts
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Link$default" :as Link]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui meta-connection-alert []
  (let [{:keys [documentationSiteUrl]} (use-subscribe [:config])]
    ($ Alert {:severity "info"}
       "Connect your Meta account to start using this integration. "
       ($ Link {:href (str documentationSiteUrl "/articles/23845086057116-Adding-and-Selecting-Meta-Credentials-in-the-Platform")
                :target "_blank"}
          "Learn more"))))
